/* eslint-disable import/no-anonymous-default-export */
// import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { get, size } from 'lodash';
import { GET_COUNT_TOTAL_NOTIFICATION, GET_DETAIL_NOTIFICATION, GET_LIST_NOTIFICATION, UPDATE_STATUS_NOTIFICATION } from './constant';
import { getCountNotiAPI, getDetailNotiAPI, getListNotiAPI, updateStatusNotiAPI } from './helpers';
import { ActionGetCountTotalNotiDone, ActionGetListNotiDone } from './action';

function* takeGetListNotiSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(getListNotiAPI, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
      yield put(ActionGetListNotiDone(data));
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
      yield put(ActionGetListNotiDone([]));
    }
  } catch (error) {
    action.callback?.onFail?.(get(error, 'response.data', ''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takeGetCountNotiSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(getCountNotiAPI, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
      yield put(ActionGetCountTotalNotiDone(data));
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
      yield put(ActionGetCountTotalNotiDone(0));
    }
  } catch (error) {
    action.callback?.onFail?.(get(error, 'response.data', ''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takeUpdateStatusNotiSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(updateStatusNotiAPI, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error, 'response.data', ''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takeGetDetailNotiSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(getDetailNotiAPI, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error, 'response.data', ''));
  } finally {
    action.callback?.onFinish?.()
  }
}

export default function* () {
  yield takeLatest(GET_LIST_NOTIFICATION, takeGetListNotiSaga);
  yield takeLatest(GET_COUNT_TOTAL_NOTIFICATION, takeGetCountNotiSaga);
  yield takeLatest(UPDATE_STATUS_NOTIFICATION, takeUpdateStatusNotiSaga);
  yield takeLatest(GET_DETAIL_NOTIFICATION, takeGetDetailNotiSaga);
}

